import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosPrimosTurismo = {
    ...dadosAgenciaComum,
    id: 'primosturismo',
    nome: 'Primos Turismo',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-NHVKV45']
};
